import { getBestMeetEventTime } from "src/utils/getBestMeetEventTime";
import getUserAge from "src/utils/getUserAge";
import { meetEligibilityMap } from "src/utils/meetConstants";
import {
  Gender,
  meet,
  MeetCourseType,
  MeetEventType,
  MeetSessionFormat,
} from "types/code-generator";

export function getEligibleMeetEvents(args: {
  user: {
    id: string;
    birthDate: Date;
    gender: Gender;
  };
  meet: meet["meet"];
  results: {
    time: Date;
    stroke: string;
    distance: number;
    course: MeetCourseType;
    type: MeetEventType;
  }[];
  entries: meet["meet"]["meetDeclarations"][0]["entries"];
}) {
  const meetEvents =
    args.meet?.sessions
      .flatMap((s) => s.meetEvents)
      .filter((e) => {
        return (
          e.format === MeetSessionFormat.TimedFinals ||
          e.format === MeetSessionFormat.Prelims
        );
      }) || [];

  const eligibleEvents = meetEvents.filter((e) => {
    const genderMatch = e.gender ? args.user.gender === e.gender : true;
    const ageUpAge =
      args.user.birthDate &&
      getUserAge(
        args.user.birthDate,
        args.meet.ageUpDate || args.meet.startDate
      );

    if (!ageUpAge && e.maxAge) {
      return false;
    }

    const ageMatch =
      ageUpAge.ageNumber >= e.minAge && ageUpAge.ageNumber <= e.maxAge;

    let userResults = args.results.filter((r) => {
      const strokeMatch = r.stroke === e.stroke;
      const distanceMatch = r.distance === e.distance;
      let courses = [args.meet.course];

      if (
        args.meet.eligibleCourses &&
        meetEligibilityMap[args.meet.eligibleCourses]
      ) {
        courses = meetEligibilityMap[args.meet.eligibleCourses];
      }

      const courseMatch = courses.includes(r.course);

      return strokeMatch && distanceMatch && courseMatch;
    });
    const isRelay = e.type === MeetEventType.Relay;

    const typeMatch =
      !isRelay || (isRelay && args.entries.find((e) => e.meetEventId === e.id));

    if (userResults.length === 0) {
      userResults = args.results.filter(
        (r) => r.stroke === e.stroke && r.distance === e.distance
      );
    }

    // console.log("timeStandard", timeStandard);

    const hasFasterThan =
      e.fasterThanLCM || e.fasterThanSCM || e.fasterThanYards;
    const hasSlowerThan =
      e.slowerThanLCM || e.slowerThanSCM || e.slowerThanYards;

    const eligibleTime = getBestMeetEventTime({
      meet: args.meet,
      meetEvent: e,
      meetResults: args.results,
    });

    const fastestTime = getBestMeetEventTime({
      meet: {
        ...args.meet,
        enforceTimeStandards: false,
      },
      meetEvent: e,
      meetResults: args.results,
    });

    let timeEligible = Boolean(eligibleTime);

    if (hasSlowerThan && !hasFasterThan && !eligibleTime && !fastestTime) {
      // NT is eligible for slower than
      timeEligible = true;
    }

    if (!hasFasterThan && !hasSlowerThan && !eligibleTime && !fastestTime) {
      // NT is eligible for no time standards
      timeEligible = true;
    }

    if (!args.meet.enforceTimeStandards) {
      timeEligible = true;
    }

    // if (e.id === "cm5wpmfzd0e6sol0yvin27djt") {
    //   console.log("args.results", args.results);
    //   console.log("eligibleTime", eligibleTime);
    //   console.log("fastestTime", fastestTime);
    //   console.log("timeEligible", timeEligible);
    //   console.log("genderMatch", genderMatch);
    //   console.log("ageMatch", ageMatch);
    // }

    return timeEligible && genderMatch && ageMatch && typeMatch;
  });

  const ineligibleEvents = meetEvents.filter((e) => {
    const genderMatch = args.user.gender === e.gender;
    const age = getUserAge(
      args.user.birthDate,
      args.meet.ageUpDate || args.meet.startDate
    );
    const ageMatch = age.ageNumber >= e.minAge && age.ageNumber <= e.maxAge;
    const isRelay = e.type === MeetEventType.Relay;

    const typeMatch =
      !isRelay || (isRelay && args.entries.find((e) => e.meetEventId === e.id));

    let userResults = args.results.filter(
      (r) =>
        r.stroke === e.stroke &&
        r.distance === e.distance &&
        r.course === args.meet.course
    );

    if (userResults.length === 0) {
      userResults = args.results.filter(
        (r) => r.stroke === e.stroke && r.distance === e.distance
      );
    }

    const eligible = eligibleEvents.find((ee) => ee.id === e.id);

    // if (e.id === "cm5bg6jxj04o6oq1ie12odc6b") {
    //   console.log("genderMatch", genderMatch);
    //   console.log("ageMatch", ageMatch);
    //   console.log("typeMatch", typeMatch);
    // }

    return !eligible && genderMatch && ageMatch && typeMatch;
  });

  return {
    eligibleEvents,
    ineligibleEvents,
  };
}
